(() => {
  if (window.__deferSectionInitLoaded) return;
  window.__deferSectionInitLoaded = true;

  const DESKTOP_QUERY = '(min-width: 750px)';
  const DEFAULT_ROOT_MARGIN = '220px 0px';
  const DEFAULT_VISIBLE_CLASS = 'is-visible';

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function shouldForceInit(section) {
    if (!section) return true;

    return (
      section.closest('header') ||
      section.matches('header, .shopify-section-header, .section-header') ||
      section.querySelector('header') ||
      section.querySelector('predictive-search-component') ||
      section.querySelector('.predictive-search') ||
      section.querySelector('.search-modal') ||
      section.querySelector('[data-search-modal]') ||
      section.querySelector('[aria-label*="Search"]') ||
      section.querySelector('[aria-label*="search"]') ||
      section.querySelector('summary[aria-label*="Search"]') ||
      section.querySelector('summary[aria-label*="search"]') ||
      section.querySelector('button[name="search"]') ||
      section.querySelector('input[type="search"]') ||
      section.querySelector('.header__search') ||
      section.querySelector('.search__button') ||
      section.querySelector('.search-modal__form') ||
      section.querySelector('cart-drawer') ||
      section.querySelector('.cart-drawer') ||
      section.querySelector('.menu-drawer') ||
      section.querySelector('[data-cart-drawer]')
    );
  }

  function markSectionReady(section) {
    if (!section) return;

    const visibleClass =
      section.dataset.deferVisibleClass || DEFAULT_VISIBLE_CLASS;

    section.classList.add(visibleClass);
    section.dataset.deferReady = 'true';
  }

  function initDeferredSection(section) {
    if (!section) return;
    if (section.dataset.deferReady === 'true') return;

    const shouldDefer = section.dataset.deferInit === 'true';
    const rootMargin =
      section.dataset.deferRootMargin || DEFAULT_ROOT_MARGIN;

    if (isDesktop() || !shouldDefer || shouldForceInit(section)) {
      markSectionReady(section);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      markSectionReady(section);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          markSectionReady(section);
          obs.unobserve(section);
        });
      },
      {
        rootMargin,
      }
    );

    observer.observe(section);
  }

  function initAllDeferredSections(scope = document) {
    if (!scope) return;

    const sections = scope.querySelectorAll('[data-defer-init]');
    if (!sections.length) return;

    sections.forEach((section) => {
      initDeferredSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAllDeferredSections(document);
      },
      { once: true }
    );
  } else {
    initAllDeferredSections(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllDeferredSections(event.target);
  });
})();